@if(noRouting()){
	<ng-content />
}
@else{
	<ion-router-outlet
		style="display: flex;
			flex-direction: column;
			height: 100px;
			flex-grow: 1;
			position: relative;">
	</ion-router-outlet>
}
